import React, { memo, forwardRef } from "react";
const SvgAlphabetW = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.03 19.75c-.187.533-.433.88-.74 1.04-.293.147-.567.22-.82.22s-.533-.073-.84-.22c-.307-.16-.553-.507-.74-1.04l-1.9-5.64h-.04l-1.88 5.64a2.03 2.03 0 01-.32.66c-.12.16-.253.287-.4.38-.133.08-.28.133-.44.16-.147.04-.28.06-.4.06s-.253-.02-.4-.06a1.466 1.466 0 01-.44-.16 2.096 2.096 0 01-.4-.38 2.348 2.348 0 01-.34-.66l-2.52-7.02a1.44 1.44 0 01-.08-.3 1.735 1.735 0 01-.02-.24c0-.347.113-.62.34-.82.227-.213.513-.32.86-.32.227 0 .447.067.66.2.213.12.387.393.52.82l1.86 6.04h.04l1.92-5.86c.093-.28.2-.5.32-.66.12-.173.247-.3.38-.38.133-.093.267-.153.4-.18a1.938 1.938 0 01.78 0c.147.027.287.087.42.18.133.08.26.207.38.38.12.16.227.38.32.66l1.9 5.86h.04l1.92-6.08c.133-.4.307-.66.52-.78a1.2 1.2 0 01.64-.2c.333 0 .607.107.82.32.227.2.34.46.34.78 0 .053-.013.133-.04.24-.013.107-.04.22-.08.34l-2.54 7.02z"
      />
    </svg>
  );
});
SvgAlphabetW.displayName = "SvgAlphabetW";
const MemoForwardRef = memo(SvgAlphabetW);
export default MemoForwardRef;
